import { useState, useEffect, useRef } from "react";
import Menu from "../components/Menu";
import ImageZoom from "../components/ImageZoom";
import { motion, AnimatePresence } from "framer-motion";
import title from "../images/1.jpg";
import { Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Captions from "yet-another-react-lightbox/plugins/captions";
import "yet-another-react-lightbox/plugins/captions.css";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";

export default function Home() {
  const [showText, setShowText] = useState(false);
  const [showImages, setShowImages] = useState(false);
  const graySectionRef = useRef(null);
  const imagesSectionRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const [photos, setPhotos] = useState([]);
  const API_BASE = "https://tomaszfotograf.pl";
  const [ipAddress, setIPAddress] = useState("");

  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => {
        setIPAddress(data.ip);
      })
      .catch((error) => console.log(error));
  }, []);

  useEffect(() => {
    fetch("save_ip.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ip: ipAddress }),
    });
  }, [ipAddress]);

  useEffect(() => {
    const fetchPhotos = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/photos`);
        if (!res) throw new Error("Błąd pobierania danych z API");
        const data = await res.json();
        const prepared = data.map((item) => {
          const date =
            item.timestamp && !isNaN(item.timestamp)
              ? new Date(item.timestamp * 1000)
              : null;
          return {
            ...item,
            fullSrc: `${API_BASE}${item.fullUrl}`,
            miniSrc: `${API_BASE}${item.miniUrl}`,
            dateTaken: date,
          };
        });

        prepared.sort((a, b) => {
          if (!a.dateTaken && !b.dateTaken) return b.name.localeCompare(a.name);
          if (!a.dateTaken) return 1;
          if (!b.dateTaken) return -1;
          return b.dateTaken - a.dateTaken;
        });

        setPhotos(prepared);
      } catch (err) {
        console.error("Błąd:", err);
      } finally {
        console.log("ok");
      }
    };

    fetchPhotos();
  }, []);

  useEffect(() => {
    const textTimer = setTimeout(() => setShowText(true), 900);
    const imageTimer = setTimeout(() => 1600);
    return () => {
      clearTimeout(textTimer);
      clearTimeout(imageTimer);
    };
  }, []);

  useEffect(() => {
    // Observer dla tekstu środkowej sekcji
    const textObserver = new IntersectionObserver(
      ([entry]) => {
        setShowText(entry.isIntersecting);
      },
      { threshold: 0.4 }
    );
    if (graySectionRef.current) textObserver.observe(graySectionRef.current);

    // Observer dla galerii
    const imagesObserver = new IntersectionObserver(
      ([entry]) => {
        setShowImages(entry.isIntersecting);
      },
      { threshold: 0.4 }
    );
    if (imagesSectionRef.current)
      imagesObserver.observe(imagesSectionRef.current);

    return () => {
      textObserver.disconnect();
      imagesObserver.disconnect();
    };
  }, []);

  const textVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  return (
    <>
      <Menu />
      <div className="fullpage">
        <section className="section section-dark">
          <motion.div
            className="fade-in-text"
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={textVariants}
          >
            <Row>
              <Col sm={12} md={4}>
                <p className="h1a">PROFESJONALNA FOTOGRAFIA NIERUCHOMOŚCI</p>
              </Col>
              <Col sm={12} md={8}>
                <ImageZoom src={title} alt="title" />
              </Col>
            </Row>
          </motion.div>
        </section>
        <section className="section section-gray" ref={graySectionRef}>
          <AnimatePresence>
            {showText && (
              <motion.div
                className="fade-in-text"
                initial="hidden"
                animate="visible"
                exit="hidden"
                variants={textVariants}
              >
                <Row>
                  <Col className="d-flex" md={4}>
                    <p className="h1a">
                      FILMOWE PODEJŚCIE DO PREZENTACJI WNĘTRZ
                    </p>
                  </Col>
                  <Col md={8}>
                    <p className="h4a">
                      Specjalizuję się w profesjonalnej fotografii nieruchomości
                      na terenie Warszawy i okolic.
                    </p>
                    <p className="h4a">
                      {" "}
                      Łączę doświadczenie zdobyte w branży filmowej i reklamowej
                      z techniczną precyzją oraz umiejętnością budowania
                      nastroju światłem. Dzięki temu każde wnętrze prezentuję
                      tak, jak kadr z dobrze wyreżyserowanego filmu.
                    </p>
                    <p className="h4a">
                      Pracuję dla agentów nieruchomości, właścicieli mieszkań,
                      deweloperów, projektantów wnętrz, architektów, producentów
                      mebli, hoteli, pensjonatów i restauracji.{" "}
                    </p>
                    <p className="h4a">
                      Tworzę zdjęcia, filmy, ujęcia dronem oraz spacery 360°,
                      które zwiększają atrakcyjność ogłoszeń i szybciej
                      przyciągają klientów.{" "}
                    </p>
                    <p className="h4a">
                      ✔ Zdjęcia dostarczam w ciągu 24 godzin.{" "}
                    </p>
                    <p className="h4a">
                      ✔ Dojazd do 30 km od centrum Warszawy — w cenie.{" "}
                    </p>
                    <p className="h4a">
                      ✔ Dodatkowo oferuję staging wnętrz: zwykły, premium oraz
                      wirtualny.
                    </p>
                  </Col>
                </Row>
              </motion.div>
            )}
          </AnimatePresence>
        </section>
        <section className="section section-dark images-row">
          {photos.slice(0, 9).map(({ miniSrc, dateTaken }, i) => (
            <motion.div
              key={miniSrc}
              style={{
                textAlign: "center",
                flex: "0 0 25.00%", // 3 obrazki na rząd
                boxSizing: "border-box",
                padding: "0px",
              }}
              initial={{ opacity: 0, y: 50, scale: 0.9 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              transition={{
                delay: 0.3 + i * 0.15,
                duration: 0.7,
                ease: "easeOut",
              }}
            >
              <img
                src={miniSrc}
                alt={`miniatura-${i}`}
                style={{
                  width: "100%",
                  maxWidth: 450,
                  height: "auto",
                  objectFit: "cover",
                  cursor: "pointer",
                  padding: 0,
                  background: "#fff",
                  borderRadius: 0,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  transition: "transform 0.2s",
                }}
                onClick={() => {
                  setIndex(i);
                  setOpen(true);
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.transform = "scale(1.05)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.transform = "scale(1.0)")
                }
              />
            </motion.div>
          ))}
        </section>
      </div>
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        index={index}
        slides={photos.map((p) => ({
          src: p.fullSrc,
        }))}
        plugins={[Captions, Slideshow, Zoom]}
        zoom={{
          maxZoomPixelRatio: 3,
          zoomInMultiplier: 2,
          doubleTapDelay: 300,
          scrollToZoom: true,
        }}
        slideshow={{ autoplay: true, delay: 4000 }}
      />
    </>
  );
}
